import { Link } from "react-router-dom";

function Header({ search, setSearch }) {
  return (
    <div>
      <div
        style={{
          width: "100%",
          background: "#111827",
          color: "white",
          textAlign: "center",
          padding: "8px",
        }}
      >
        Online ordering coming soon. Stay tuned!
      </div>

      <div
        style={{
          background: "white",
          padding: "18px 30px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
          position: "sticky",
          top: 0,
          zIndex: 100,
        }}
      >
        {/* Logo */}
        <img
          src="/manna-logo.jpg"
          alt="Manna"
          onError={(e) => {
            e.currentTarget.src = "/logo192.png";
          }}
          style={{
            height: "52px",
            width: "auto",
            display: "block",
          }}
        />

        {/* Navigation */}
        <div style={{ display: "flex", alignItems: "center", gap: "20px", position: "absolute", left: "50%", transform: "translateX(-50%)" }}>
          <Link
            to="/"
            style={{
              textDecoration: "none",
              color: "#111827",
              fontWeight: "600",
            }}
          >
            Home
          </Link>

          <Link
            to="/catalogue"
            style={{
              textDecoration: "none",
              color: "#111827",
              fontWeight: "600",
            }}
          >
            Catalogue
          </Link>

          <Link
            to="/order-status"
            style={{
              textDecoration: "none",
              color: "#111827",
              fontWeight: "600",
            }}
          >
            Track Order
          </Link>
        </div>

        {/* Search */}
        <input
          type="text"
          placeholder="Search products..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{
            width: "320px",
            padding: "10px 14px",
            borderRadius: "8px",
            border: "1px solid #d1d5db",
            outline: "none",
          }}
        />
      </div>
    </div>
  );
}

export default Header;
